import styled from 'styled-components';

const NavFlex = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem;
  width: 22vh;
  min-width: 22vh;
  flex-grow: 0;
  /* max-width: 17vw; */
  border-right: 0.5px solid var(--blackGreen);
  && > div {
    height: calc(50vh - 2rem);
    width: 100%;
  }

  .nav-links a {
    opacity: var(--opacity);
    &[aria-current='page'] {
      color: var(--focus);
    }
  }

  a:hover {
    /* opacity: var(--opacityOver); */
  }

  @media (min-width: 1568px) {
    width: 26vh;
    min-width: 26vh;
  }
`;

export default NavFlex;
